import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExternal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 18.5C5 19.05 5.45 19.5 6 19.5H18C18.55 19.5 19 19.05 19 18.5V13.5C19 12.95 19.45 12.5 20 12.5C20.55 12.5 21 12.95 21 13.5V19.5C21 20.6 20.1 21.5 19 21.5H5C3.9 21.5 3 20.6 3 19.5V5.5C3 4.4 3.89 3.5 5 3.5H11C11.55 3.5 12 3.95 12 4.5C12 5.05 11.55 5.5 11 5.5H6C5.45 5.5 5 5.95 5 6.5V18.5ZM15 5.5C14.45 5.5 14 5.05 14 4.5C14 3.95 14.45 3.5 15 3.5H21V9.5C21 10.05 20.55 10.5 20 10.5C19.45 10.5 19 10.05 19 9.5V6.91L9.87 16.04C9.48 16.43 8.85 16.43 8.46 16.04C8.07 15.65 8.07 15.02 8.46 14.63L17.59 5.5H15Z",
		fill: "white"
	})
});
export { SvgExternal as ReactComponent };
